import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { graphql } from 'gatsby'
import sanitizeHtml from 'sanitize-html'
import * as cheerio from 'cheerio'

const Wrapper = styled.section`
  ${tw`max-w-7xl mx-auto px-8 pb-16`}
`

const Content = styled.div`
  ${tw`max-w-3xl mx-auto`}
  h2::after {
    content: '.';
    ${tw`text-primary`}
  }
  strong {
  ${tw`text-primary font-bold`}
`

const Body = ({ data }) => {
  const $ = cheerio.load(data.content, { decodeEntities: true })
  $('h2').each(function () {
    $(this).attr(
      'class',
      $(this)
        .html()
        .replace(/[^a-z0-9]/gi, '_')
        .toLowerCase()
    )
  })

  const html = $.html()

  return (
    <Wrapper>
      <Content
        className="prose lg:prose-xl"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(html, {
            allowedAttributes: {
              h2: ['id', 'class'],
              a: ['href', 'target'],
            },
          }),
        }}
      />
    </Wrapper>
  )
}

export default Body

Body.propTypes = {
  data: PropTypes.object.isRequired,
}

export const bodyData = graphql`
  fragment Body on WpPage_Pagebuilder_Layouts_Body {
    content
    fieldGroupName
  }
`
